module.exports = __webpack_public_path__ + "160c07911df85e32ff5a1d7396e40209.jpg";